import { DATA_GIF_PATH, ICON_BASE_PATH } from "@/app/utils/config";

import "../smeonboarding.css";
import { useToken } from "@/app/services/context/TokenContext";
import { redirectToGrowXLogout } from "@/app/utils/loginservice/redirectToGrowXLogout";

const RequestSentSuccessfully = () => {
  const { logout } = useToken();

  // ........................................handleLogout.............................
  const handleLogout = () => {
    setTimeout(redirectToGrowXLogout, 0);
    logout();
  };

  return (
    <div className="gx-smeonboard-card">
      <div className="gx-smeonboard-child">
        <div className="gx-smeonboard-box">
          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-12">
              <div className="gx-login-success-img">
                <img src={`${DATA_GIF_PATH}Hourglass.gif`} alt="Success" />
              </div>
            </div>
            <div className="col-span-12">
              <div className="gx-request-progress-title">
                <h2 className="gx-h2-l">
                  Request {""}
                  <span className="gx-h2-b">Sent Successfully</span>
                </h2>
                <p className="gx-p12-m">
                  Your onboarding request has been shared with the
                  owner/administrator. You’ll be able to continue once your
                  access is approved
                </p>
              </div>
            </div>
            <div className="col-span-12">
              <div className="gx-request-progress">
                {" "}
                <p>Your Request In Progress...</p>
              </div>
            </div>
            <div className="col-span-12">
              <div className="gx-connectbank-logout">
                <button onClick={handleLogout}>
                  <img src={`${ICON_BASE_PATH}logouticon.svg`} alt="name" />
                  <span>Logout</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RequestSentSuccessfully;
